import * as yup from 'yup'

const baseSchema = {
  appVersion: yup.string().required(),
  // .test(
  //   'matchValue', 
  //   (val) => `${val.value} is not match`, 
  //   value => value && value.trim() === 'test'
  // ),
  buildNumber: yup.number().required().typeError('Build Number must be a "number" type').min(0, 'Build Number must be a positive number'),
  customCode: yup.string().nullable().max(100, 'Custom Code must be at most 100 characters'),
  buildTarget: yup.object({
    androidModern: yup.boolean(),
    androidLegacy: yup.boolean(),
    androidMpos: yup.boolean(),
    ios: yup.boolean(),
  }).required().test(
    'atLeastOneTrue',
    'At least one build target must be selected',
    (value) => value && (value?.androidModern || value?.androidLegacy || value?.androidMpos || value?.ios)
  ),
  remarks: yup.string().nullable(),
  // status: yup.string().required(),
  releaseNote: yup.string().nullable().max(500, 'Release Note must be at most 500 characters'),
  remarks: yup.string().nullable().max(1000, 'Remarks must be at most 500 characters'),
  file: yup.mixed()
    .when('buildTarget', {
      is: (buildTarget) => buildTarget?.ios === true && !buildTarget.androidModern && !buildTarget.androidLegacy && !buildTarget.androidMpos,
      then: (schema) => schema.notRequired().nullable(),
      otherwise: (schema) => schema.required('File is required when build target includes Android').test(
        'fileExist',
        'Please upload APK file',
        (value) => value && (value.cosFileKey != null && value.cosFileKey !== undefined) || (value.cosFileUrl != null && value.cosFileUrl !== undefined)
      ),
    }),
}

const createSchema = yup.object().shape({
  ...baseSchema,
  // status not required for create in original code
})

const editSchema = yup.object().shape({
  ...baseSchema,
})

function formatYupError(err) {
  const map = {}
  if (!err || !err.inner) return map
  err.inner.forEach((e) => {
    const path = e.path || '_global'
    if (!map[path]) map[path] = []
    if (!map[path].includes(e.message)) map[path].push(e.message)
  })
  return map
}

export async function validateForm(data, mode) {
  const schema = mode === 'edit' ? editSchema : createSchema
  try {
    await schema.validate(data, { abortEarly: false })
    return { valid: true, errors: {} }
  } catch (err) {
    console.error('Validation error:', err)
    return { valid: false, errors: formatYupError(err) }
  }
}
